import { createAsyncReducer, createDefaultInitialState, createReducerFromMap } from "@coverme/redux";

export const initialState = createDefaultInitialState({});

function getDocuments(state, action) {
    const value = action.value;
    const personId = value.personId;
    const documents = value.documents;
    return {
        ...state,
        [personId]: [...documents],
    };
}

function deleteDocument(state, action) {
    const personId = action.value.personId;
    const documentId = action.value.documentId;

    let documentsForPerson = state[personId];
    if (documentsForPerson == null) {
        return state;
    }

    documentsForPerson = documentsForPerson.filter(x => x.documentId != documentId);

    return {
        ...state,
        [personId]: documentsForPerson,
    };
}

export const documentsReducer = createReducerFromMap(initialState, {
    ...createAsyncReducer("GET_DOCUMENTS_FOR_PERSON", getDocuments),
    ...createAsyncReducer("DELETE_DOCUMENT_FOR_PERSON", deleteDocument),
});
